import { addMinutes, closestTo, isWithinInterval } from 'date-fns';

// only to new date
export const dateWithoutTZ = date => addMinutes(date, date.getTimezoneOffset());

export const getDateInTheRange = boundaries => date => {
  if (boundaries == null) return boundaries;
  if (boundaries.includes(undefined)) return undefined;
  if (date == null || boundaries.length === 0) return date;
  const [start, end] = boundaries;
  return isWithinInterval(new Date(date), {
    start: new Date(start),
    end: new Date(end),
  })
    ? date
    : closestTo(new Date(date), [new Date(start), new Date(end)]);
};
